import lodash from "lodash";
import { createFieldInput } from "../../../../components/input/template-builder/template-builder.logic";
import { createColumnInput } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { conditionFormChecker, putField } from "../../../../utils/form";

export const callCompanyRoleMgt = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "COMPANY_ROLE_MGT", value: searchQuery });

export const createColumns = () => {
    const columns = [createColumnInput({ title: () => i18n.global.t("model.role.name"), dataIndex: "desc", width: 200 })];
    return columns;
};

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}name`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.role.name"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.desc, "onUpdate:value": value => (model.desc = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            })
        ]
    });
};

export const filterCompanyRoleMgt = ({ roles, userObjectives, companyRoleMgts }) => {
    const userObjectiveKeys = userObjectives.map(d => d.refObjective.key);
    return roles
        .map(d => {
            const companyRoleMgt = companyRoleMgts.find(d2 => d.name === d2.key);
            return { ...d, attribute: companyRoleMgt?.attribute, seq: companyRoleMgt?.seq };
        })
        .filter(d => {
            return (
                d.attribute?.objectiveKeys?.some(d2 => userObjectiveKeys.includes(d2)) ||
                d.attribute?.addRoleObjectiveKeys?.some(d2 => userObjectiveKeys.includes(d2))
            );
        })
        .sort((o1, o2) => o1.seq - o2.seq);
};
